/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from "react"
import Icon from "@mui/material/Icon"
import { IconButton } from "@mui/material"
import Tooltip from "@mui/material/Tooltip"
import { useTranslation } from "react-i18next"
import { PageConfig, CwComponentConfig } from "../../models/pageConfig"
import UIService from "../../services/UIService"
import { Action } from "../../models/action"
import ActionService from "../../services/action"
import { Color } from "../../models/colors"
import DialogService from "../../services/dialog"
import { DialogType } from "../../models/dialog"

interface State {
    onClickActions?: Array<Action>
    name?: string
    tooltip?: any
    fontSize?: "inherit" | "large" | "small" | "medium" | undefined
    color?: Color
    className?: string
}
const CwIcon = (
    props: PageConfig<CwComponentConfig.Icon> & {
        onSubmit?: (value: any) => void
    }
): React.JSX.Element | null => {
    const { config } = props
    const { clickable, useRefreshListener, context } = config
    const [state, setState] = useState<State>({
        onClickActions: config.onClickActions,
        name: config.name,
        tooltip: config.tooltip,
        fontSize: config.fontSize,
        color: config.color,
        className: config.className || "",
    })
    const iconColor = state.color
        ? UIService.getColorByName(state.color)
        : "black"
    // traduction
    const { t } = useTranslation()
    const init = () => {
        if (props.actions && props.actions.length)
            ActionService.exec(props.actions, context).then((conf) => {
                // override des attrs de state par ceux de conf
                // -----> dans icon
                if (conf?.type === "config") {
                    setState({ ...state, ...conf.value })
                }
            })
    }
    useEffect(() => {
        let subId: null | string = null
        // on s'abonne aux changements de route
        if (useRefreshListener) {
            subId = DialogService.getInstance().subscribe(
                "pageRefesh",
                DialogType.REFRESH,
                props.name,
                () => {
                    init()
                }
            )
        }
        init()
        // unsubscribe
        return () => {
            if (subId) DialogService.getInstance().unsubscribe(subId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    /**
     * handleClick gére les clics sur les images clickable
     */
    const handleClickOnIcon = () => {
        // récupère les actions à faire lors du click
        if (state.onClickActions) {
            // ici c'est onClickActions
            const actions: Array<Action> = state.onClickActions
            // executer les actions
            ActionService.exec(actions, context).then(
                () => {},
                (err) => {
                    console.error(err)
                }
            )
        }
    }

    if (clickable) {
        return state.tooltip ? (
            <Tooltip
                title={t(state.tooltip.title)}
                placement={state.tooltip.placement}
                TransitionProps={{ timeout: 600 }}
            >
                <IconButton onClick={handleClickOnIcon}>
                    <Icon
                        fontSize={state.fontSize}
                        className={state.className}
                        style={{ color: iconColor }}
                    >
                        {state.name}
                    </Icon>
                </IconButton>
            </Tooltip>
        ) : (
            <IconButton onClick={handleClickOnIcon}>
                <Icon
                    fontSize={state.fontSize}
                    className={state.className}
                    style={{ color: iconColor }}
                >
                    {state.name}
                </Icon>
            </IconButton>
        )
    }

    return state.tooltip ? (
        <Tooltip
            title={t(state.tooltip.title)}
            placement={state.tooltip.placement}
            TransitionProps={{ timeout: 600 }}
        >
            <Icon
                fontSize={state.fontSize}
                className={state.className}
                style={{ color: iconColor }}
            >
                {state.name}
            </Icon>
        </Tooltip>
    ) : (
        <Icon
            fontSize={state.fontSize}
            className={state.className}
            style={{ color: iconColor }}
        >
            {state.name}
        </Icon>
    )
}

export default CwIcon
